module.exports = __webpack_public_path__ + "img/emoji-kiss-80x80.cc36d646.png";